import AllUsers from "./routes/Users/Users.vue";
import DetailUser from "./routes/Users/form/DetailUser.vue";

import Buyers from "./routes/Buyers/Buyers.vue";
import BuyerDetail from './routes/Buyers/Detail.vue';
import Sellers from "./routes/Sellers/Sellers.vue";
import SellerDetail from './routes/Sellers/Detail.vue';
import Roles from "./routes/Roles/Roles.vue";

const usersRoutes = [
  {
    path: ":id",
    name: "DetailUser",
    component: DetailUser,
  },
  {
    path: "all-users",
    name: "All-Users",
    component: AllUsers,
  },
  {
    path: "buyers",
    name: "Buyers",
    component: Buyers,
  },
  {
    path: "buyers/:id",
    name: "Buyers Detail",
    component: BuyerDetail,
  },
  {
    path: "sellers",
    name: "Sellers",
    component: Sellers,
  },
  {
    path : "sellers/:id",
    name : "Sellers Detail",
    component : SellerDetail,
  },
  {
    path: "roles",
    name: "Roles",
    component: Roles,
  },
];

export default usersRoutes;
